export default __webpack_public_path__ + "static/media/socicon.fa1cafd6.woff";